// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FEsP","colBig":"styles_colBig__16R8P","colSmall":"styles_colSmall__17sYo"};